import React, { useMemo } from "react";
import { useChainbridge } from "../../contexts/ChainbridgeContext/ChainbridgeContext";
import { useNetworkManager } from "../../contexts/NetworkManagerContext/NetworkManagerContext";
import { Button, Modal, LinearProgress, Typography, Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { OutlinedButton } from "../../components/Button";
import { modalClasses } from "../../utils/classes";

const NetworkSelectModal = () => {
  const { isReady, chains } = useChainbridge();
  const { walletType, setWalletType } = useNetworkManager();
  const theme = useTheme();
  const isOpen = useMemo(() => {
    return walletType !== "unset" && walletType !== "Ethereum" && !isReady;
  }, [walletType, isReady]);

  const hasSubstrateExtension = window.injectedWeb3 && (window.injectedWeb3["polkadot-js"] || window.injectedWeb3["subwallet-js"]) !== undefined;
  const installExtension = "Install Polkadot{.js} extension to use";
  const toolTip = hasSubstrateExtension ? "" : <Typography variant="body1"><a href="https://polkadot.js.org/extension/" target="_blank">{installExtension}</a></Typography>;

  return (
    <Modal open={isOpen}>
      <Box sx={modalClasses}>
        {walletType === "select" && (
          <>
            <Typography
              variant="h3"
              color="#ffffff"
              fontWeight={700}
              fontSize={theme.spacing(6)}
            >
              Please select a wallet type
            </Typography>
            <Box mt={theme.spacing(7)} display="flex" gap={theme.spacing(5)} sx={{
              [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
              },
            }}>
              {chains?.every((item) => item.type === "Ethereum") ? (
                <Button onClick={() => setWalletType("Ethereum")}>
                  Use Ethereum wallet
                </Button>
              ) : (
                <>
                  <OutlinedButton
                    onClick={() => setWalletType("Ethereum")}
                    variant="outlined"
                  >
                    Use Ethereum wallet
                  </OutlinedButton>
                  <Tooltip title={toolTip} placement="top">
                    <span style={{ width: "100%" }}>
                      <OutlinedButton
                        onClick={() => setWalletType("Substrate")}
                        disabled={!hasSubstrateExtension}
                        variant="outlined"
                      >
                        Use DENTNet wallet
                      </OutlinedButton>
                    </span>
                  </Tooltip>
                </>
              )}
            </Box>
          </>
        )}
        {walletType === "Substrate" && (
          <>
            <Typography
              variant="h3"
              color="#ffffff"
              fontWeight={700}
              fontSize={theme.spacing(6)}
            >
              Connecting to node
            </Typography>
            <LinearProgress color="primary" />
          </>
        )}
      </Box>
    </Modal>
  );
};

export default NetworkSelectModal;
